import React from 'react'

import { FormattedHTMLMessage, InfiniteScroll } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import { lang } from './lang'
import { useTransactionsList } from './hooks'
import EmptyHistory from './Empty'
import HistoryError from './Error'
import List from './List'
import { Transaction } from '~pages/CardsPage/Cards/Transactions/types'

interface Props {
    onRowClick: (tx: Transaction) => void
    card?: GetCard
}

function ListWrapper({ onRowClick, card }: Props) {
    const { data, isError, fetchNext, hasMore, isLoading, isInitialLoad } = useTransactionsList(card?.id)

    const isEmptyHistoryError = isError && !data?.length && !isLoading
    const isEmptyHistory = !data?.length && !isLoading && !isInitialLoad

    if (isEmptyHistory) {
        return <EmptyHistory card={card} />
    }

    if (isEmptyHistoryError) {
        return <HistoryError onRefresh={fetchNext} />
    }

    return (
        <InfiniteScroll
            hasMore={hasMore}
            loadMore={() => {
                if (!isLoading) {
                    fetchNext()
                }
            }}
            initialLoad
            errorMessage={<FormattedHTMLMessage {...lang.errorText} />}
            retryBtnText={<FormattedHTMLMessage {...lang.retryBtn} />}
            isError={isError}
            noMoreDataMessage={<FormattedHTMLMessage {...lang.noMoreData} />}
            useWindow={false}
        >
            <List data={data || []} onRowClick={onRowClick} />
        </InfiniteScroll>
    )
}

export default ListWrapper
